import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { EventAvailable } from '@material-ui/icons';
import commonMessages from 'common/messages/messages';
import { ActionItem } from 'common/components';
import { allowRedeemAppointmentByTime } from 'utils/booking.utils';
import { PersonAppointmentStatus } from 'modules/booking/interfaces';
import messages from 'modules/booking/messages';
import ActionItemWarningIconByTime from 'common/components/ActionsMenu/ActionItemWarningIconByTime';
import ActionItemWarningIcon from 'common/components/ActionsMenu/ActionItemWarningIcon';
import BookingActionItemContainer from 'components/Booking/BookingActionItemContainer';

interface IBookingActionItemRedeem {
  onClick: () => void;
  appointmentStatus: PersonAppointmentStatus;
  secondsBeforeEvent: number;
  hasScheduledService: boolean;
  isEventCanceled: boolean;
}

const BookingActionItemRedeem: FC<IBookingActionItemRedeem> = ({
  onClick,
  appointmentStatus,
  secondsBeforeEvent,
  hasScheduledService,
  isEventCanceled,
}) => {
  const intl = useIntl();
  const isAttended = appointmentStatus === PersonAppointmentStatus.Attended;
  let disableReason: JSX.Element | null = null;

  if (isEventCanceled) {
    disableReason = (
      <ActionItemWarningIcon tooltipMessage={intl.formatMessage(messages.eventIsCanceled)} />
    );
  } else if (isAttended) {
    disableReason = (
      <ActionItemWarningIcon tooltipMessage={intl.formatMessage(messages.eventIsRedeemed)} />
    );
  } else if (!hasScheduledService) {
    disableReason = (
      <ActionItemWarningIcon
        tooltipMessage={intl.formatMessage(messages.eventHasNoScheduledService)}
      />
    );
  } else if (!allowRedeemAppointmentByTime(secondsBeforeEvent)) {
    disableReason = <ActionItemWarningIconByTime tooltipMsgType="restrictRedeem" />;
  }

  const disabled = !!disableReason;

  return (
    <ActionItem
      key="redeemEventAction"
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      icon={<EventAvailable />}
    >
      <BookingActionItemContainer message={intl.formatMessage(commonMessages.redeemBtn)}>
        {disableReason}
      </BookingActionItemContainer>
    </ActionItem>
  );
};

export default BookingActionItemRedeem;
